import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { UpdateUserRequest } from '../../pages/main/profile/update-user-request';
import { Observable } from 'rxjs';
import { TeacherMarketPlaceRequest, TeacherProficienciesRequest } from '@models/contracts/contracts';
import { ValueWrapper } from '@models/response/value-wrapper';

@Injectable({
  providedIn: 'root'
})
export class ProfileService extends BaseService {
  private entityUrl: string = 'user';
  constructor(http: HttpClient) {
    super(http);
  }

  updateProfile(id: number, request: UpdateUserRequest): Observable<any> {
    return this.http.put(`${this.baseUrl + this.entityUrl}/${id}`, request);
  }

  updateTeacherProficiencies(id: number, request: TeacherProficienciesRequest): Observable<any> {
    return this.http.put(`${this.baseUrl + this.entityUrl}/${id}/market-place`, request);
  }

  updateTeacherMarketPlace(id: number, request: TeacherMarketPlaceRequest): Observable<any> {
    return this.http.put(`${this.baseUrl + this.entityUrl}/${id}/market-place`, request);
  }

  getProfile(id: number) {
    return this.http.get<any>(`${this.baseUrl + this.entityUrl}/${id}`);
  }

  getProfileImage(id: number) {
    return this.http.get<any>(`${this.baseUrl + this.entityUrl}/${id}/profile-img`);
  }

  getTeacherDocs(userId: number): Observable<any> {
    return this.http.get(`${this.baseUrl + this.entityUrl}/${userId}/docs`);
  }

  getTeacherUsername(userId: number): Observable<ValueWrapper<string>> {
    return this.http.get<any>(this.baseUrl + this.entityUrl + `/${userId}/teacher-username`);
  }

  loadEnrolledCourses() {
    return this.http.get<any>(`${this.baseUrl + this.entityUrl}/load-enrolled-courses`);
  }

  isCurriculumOwner(curriculumId: number): Observable<ValueWrapper<boolean>> {
    return this.http.get<any>(`${this.baseUrl + this.entityUrl}/is-curriculum-owner/${curriculumId}`);
  }

  canReadCourse(courseGuid: string) {
    return this.http.get<any>(`${this.baseUrl + this.entityUrl}/can-read-course/${courseGuid}`);
  }

  canReadLesson(lessonGuid: string) {
    return this.http.get<any>(`${this.baseUrl + this.entityUrl}/can-read-lesson/${lessonGuid}`);
  }
}
